class Translation {

    translation = {}

    onDemandTranslation = null

    activeLanguage = 'en-GB'

    languages = LANGUAGES

    activeLanguage = ACTIVE_LANGUAGE

    constructor() {
        this.loadTranslation()
    }

    loadTranslation() {
        // Synchronous (async: false) so translation.get() stays usable
        // immediately after this constructor runs, same as every other
        // script on the page assumes today. Fetched the same way every
        // other /a/ endpoint already is (see translationOnDemand /
        // loadOnDemandTranslations below) rather than as a <script src>
        // tag, which doesn't go through the same request path and gets
        // rejected as unauthenticated - that's what broke in production
        // the first time this was tried.
        const result = $.ajax({
            url: `/a/translations`,
            method: "GET",
            data: {lang: this.activeLanguage},
            // As text: the endpoint answers with Content-Type
            // text/javascript, which jQuery would otherwise eval as a
            // script instead of handing us the body.
            dataType: "text",
            async: false
        })

        // The response body is a script - `window.__TRANSLATIONS__ = {...};`
        // - left over from the <script src> approach that the comment above
        // describes. Unwrap it to the JSON object it assigns; also accept a
        // bare JSON body, in case the endpoint is ever changed to send one.
        const body = (result.responseText || "").trim()
        const json = body.replace(/^window\.__TRANSLATIONS__\s*=\s*/, "")
            .replace(/;$/, "")

        if(json) {
            try {
                return this.translation = JSON.parse(json)
            } catch(e) {
                // fall through to the error below
            }
        }

        if(result.responseJSON) {
            return this.translation = result.responseJSON
        }

        throw new Error(`TRANSLATION constant not found in a global scope.`)
    }

    /**
     * @param {string} value
     */
    get(value) {
        if (this.translation) {
            if (value in this.translation) {
                return this.translation[value]
            }

            return value
        }

        throw new Error(`Translation object has not been loaded.`)
    }

    /**
     * @param {string} value
     * @param {string} lang
     */
    getOnDemand(value, lang = "en-GB") {
        var regex = /^(?:[A-Za-z0-9+/]{4})*?(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
        if (this.onDemandTranslation) {
            if (lang in this.onDemandTranslation) {
                if (value in this.onDemandTranslation[lang]) {
                    let s = this.onDemandTranslation[lang][value];
                    if( regex.test(s) ){
                        return atob(s);
                    } else {
                        return s;
                    }
                }
            }
        }

        if (this.translation) {
            if (value in this.translation) {
                let s = this.translation[value];
                if( regex.test(s) ){
                    return atob(s);
                } else {
                    return s;
                }
            }
        }

        return value
    }

    /**
     * @returns {string}
     */
    getActiveLanguage() {
        return this.activeLanguage
    }

    /**
     * @param {string} locale
     * @returns
     */
    getLanguageLabel(locale) {
        return this.languages[locale]
    }

    async loadOnDemandTranslations() {
        this.onDemandTranslation = await $.ajax(`/a/translationOnDemand`)
    }

    /**
     * Fancy sprintf to perform string replacment
     * with freely defined placeholders
     *
     * NOTE: All placeholders have to be in the folowing format:
     * [[ * ]]
     * [[ meaningful_note_of_subject_variable_to_give_translator_a_context ]]
     *
     * Fe:
     * `Welcome, [[ user_name ]]`
     * `[[ number_of_mailboxes ]] x [[ size_in_megabytes ]] Mailboxes`
     *
     * Usage:
     * translation.sprintf(
     *  `[[ number_of_mailboxes ]] x [[ size_in_megabytes ]] Mailboxes`,
     *  ['150', '2000MB']
     * )
     */
    sprintf(subject, [...args]) {
        const pattern = /\[\[(.*?)\]\]/g
        const templates = []

        let match
        while((match = pattern.exec(subject)) != null ) {
            templates.push(match[0])
        }

        if(templates.length) {
            templates.forEach((t, i) => {
                if(typeof [...args][i] !== 'undefined') {
                    subject = subject.replace(t, [...args][i])
                }
            })
        }

        return subject
    }
}

const translation = new Translation()

/** debug to remove */
const updateLanguageSettings = lang => {
    $.ajax({
        method: 'post',
        url: `/a/changeLanguage`,
        contentType: 'application/json',
        data: JSON.stringify({
            language: lang
        }),
    }).done(() => {
        window.location.reload()
    }).fail(() => {
        ShowNotification.fail(translation.get('preferences_save_fail'))
    })
}
/** debug to remove */
